var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "_mdls _d2 _con",
      class:
        ((_obj = { _v: _vm.visible && !_vm.occluded }),
        (_obj["_p" + _vm.actual] = true),
        (_obj["_a" + _vm.align] = true),
        _obj),
      attrs: { dir: _vm.direction },
      on: {
        mousedown: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c("ib-picker-date", {
        ref: "pick",
        staticClass: "_mdlsdef compact",
        attrs: {
          wheel: "",
          value: _vm.value,
          min: _vm.min,
          max: _vm.max,
          distant: _vm.distant,
          tabindex: null,
        },
        on: { input: _vm.input },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }